// Oakdale, MN bars and what they've posted publicly online, gathered
// Oct 22, 2026 from each bar's own website and mnbarbingo.com.
// Every item keeps the page it came from (sourceUrl) so it can be checked.
// Imported items are marked verified:false until the owner confirms them.
//
// Times are 24-hour "HH:MM". Days for specials use Mon/Tue/... codes;
// weekly events use full day names, matching the rest of the dashboard.

export const IMPORT_GATHERED_ON = "2026-10-22";

export const OAKDALE_BARS = [
  {
    key: "mcs-pub",
    name: "MC's Pub - Oakdale",
    address: "1267 Geneva Ave N, Oakdale, MN 55128",
    phone: "(612) 489-8144",
    website: "https://www.mcspub.com/",
    amenities: ["Pull-tabs", "E-tabs"],
    note: "17 pull-tab boxes and 12 E-tab devices per their website. Sunday bingo time varies in Vikings season (not imported).",
    specials: [
      {
        title: "Weekend breakfast",
        category: "Daily Food",
        recurrence: "days",
        days: ["Sat", "Sun"],
        startTime: "10:00",
        endTime: "13:00",
        details: "Breakfast served Saturday and Sunday mornings.",
        sourceUrl: "https://www.mcspub.com/",
      },
    ],
    events: [
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Wednesday", time: "18:00", details: "8–10 games for $20, coverall $4 extra. $1,495 guaranteed coverall.", sourceUrl: "https://mnbarbingo.com/item/mcs-pub-oakdale/" },
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Thursday", time: "18:00", details: "8–10 games for $20, coverall $4 extra. Two $1,000 coveralls.", sourceUrl: "https://mnbarbingo.com/item/mcs-pub-oakdale/" },
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Friday", time: "19:00", details: "8–10 games for $20, coverall $4 extra. $2,000 guaranteed coverall.", sourceUrl: "https://mnbarbingo.com/item/mcs-pub-oakdale/" },
      { title: "Afternoon Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Saturday", time: "13:00", details: "8–10 games for $20, coverall $4 extra. $1,495 guaranteed coverall.", sourceUrl: "https://mnbarbingo.com/item/mcs-pub-oakdale/" },
      { title: "Evening Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Saturday", time: "19:00", details: "8–10 games for $20, coverall $4 extra. $1,000 coverall.", sourceUrl: "https://mnbarbingo.com/item/mcs-pub-oakdale/" },
    ],
  },
  {
    key: "sgt-peppers",
    name: "Sgt Peppers Grill & Bar",
    address: "930 Helena Ave N, Oakdale, MN 55128",
    phone: "(651) 738-7052",
    website: "https://www.sgtpeppersgrille.com/",
    amenities: [],
    note: "Their site says daily and lunch specials change monthly but doesn't list them. mnbarbingo.com also lists a Sunday 5pm bingo that their own site doesn't (not imported).",
    specials: [
      { title: "Happy Hour", category: "Happy Hour", recurrence: "days", days: ["Mon", "Tue", "Wed", "Thu", "Fri"], startTime: "15:00", endTime: "19:00", details: "", sourceUrl: "https://www.sgtpeppersgrille.com/specials" },
      { title: "Weekend Happy Hour", category: "Happy Hour", recurrence: "days", days: ["Sat", "Sun"], startTime: "11:00", endTime: "16:00", details: "", sourceUrl: "https://www.sgtpeppersgrille.com/specials" },
    ],
    events: [
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Thursday", time: "18:00", details: "10 games for $20. $1,100 guaranteed jackpot; game 5 pays $500 guaranteed.", sourceUrl: "https://www.sgtpeppersgrille.com/" },
      { title: "Sunday Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Sunday", time: "14:00", details: "10 games for $20. $1,100 guaranteed jackpot.", sourceUrl: "https://www.sgtpeppersgrille.com/" },
    ],
  },
  {
    key: "dukes",
    name: "Duke's Pizza Pub & Grill",
    address: "1285 Geneva Ave N, Oakdale, MN 55128",
    phone: "(651) 264-0340",
    website: "http://www.dukespizzapub.com/",
    amenities: [],
    note: "Their website points to Facebook for updates; no specials are listed on the site.",
    specials: [],
    events: [
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Tuesday", time: "18:30", details: "", sourceUrl: "https://mnbarbingo.com/item/dukes-pub-grill-oakdale/" },
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Thursday", time: "18:30", details: "", sourceUrl: "https://mnbarbingo.com/item/dukes-pub-grill-oakdale/" },
      { title: "Meat Raffle", category: "Gambling", subcategories: ["Meat Raffle"], dayOfWeek: "Thursday", time: "16:00", details: "", sourceUrl: "https://mnbarbingo.com/item/dukes-pub-grill-oakdale/" },
    ],
  },
  {
    key: "wild-boar",
    name: "Wild Boar Bar & Grill - Oakdale",
    address: "950 Helena Ave N, Oakdale, MN 55128",
    phone: "(651) 414-0903",
    website: "https://oakdale.wildboarbarandgrill.com/",
    amenities: ["Family Friendly"],
    note: "Their specials page shows September dates; the weekly pattern is imported. Prices may have changed, so worth confirming.",
    specials: [
      { title: "Weekday Happy Hour Menu", category: "Happy Hour", recurrence: "days", days: ["Mon", "Tue", "Wed", "Thu", "Fri"], startTime: "11:00", endTime: "18:00", details: "$10 smash burger, grilled cheese or wing baskets. Free domestic tap with food.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Happy Hour Food & Drink", category: "Happy Hour", recurrence: "days", days: ["Mon", "Tue", "Wed", "Thu", "Fri"], startTime: "15:00", endTime: "18:00", details: "$3.75 domestic taps, bottles, wells and calls. $4.75 house wine. Buy one starter, get one 50% off.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Saturday Happy Hour", category: "Happy Hour", recurrence: "days", days: ["Sat"], startTime: "11:00", endTime: "18:00", details: "$3.50 domestic taps, bottles, wells and calls. Buy one starter, get one 50% off.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Sunday Happy Hour Drinks", category: "Daily Drink", recurrence: "days", days: ["Sun"], startTime: "12:00", endTime: "18:00", details: "$3.75 domestic taps, bottles, wells and calls. $4.75 house wine.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Half-Price Burgers", category: "Daily Food", recurrence: "days", days: ["Sun"], startTime: "11:00", endTime: "22:00", details: "Burgers half price all day.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "South of the Border Tuesday", category: "Daily Food", recurrence: "days", days: ["Tue"], startTime: "11:00", endTime: "22:00", details: "$10 Mexican menu. $5.50 margaritas.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Wing It Wednesday", category: "Daily Food", recurrence: "days", days: ["Wed"], startTime: "17:00", endTime: "22:00", details: "5 wings $5, 10 for $10, 15 for $15.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Thursday Ribs", category: "Daily Food", recurrence: "days", days: ["Thu"], startTime: "11:00", endTime: "22:00", details: "$15.99 half rack with a side and coleslaw.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Friday Fish Fry", category: "Daily Food", recurrence: "days", days: ["Fri"], startTime: "11:00", endTime: "22:00", details: "$17.99 cod with fries, potato salad and coleslaw.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
      { title: "Kids Eat Free", category: "Daily Food", recurrence: "days", days: ["Sat"], startTime: "17:00", endTime: "21:00", details: "One free kids meal per paying adult.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-happy-hours-specials" },
    ],
    events: [
      { title: "Bar Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Wednesday", time: "18:30", details: "8 games, $25 per packet. Odd/even coverall pays $250.", sourceUrl: "https://mnbarbingo.com/item/wild-boar-bar-grill-oakdale/" },
      { title: "Saturday Bingo", category: "Gambling", subcategories: ["Bingo"], dayOfWeek: "Saturday", time: "13:00", details: "$1,000 in 56 numbers or less, $500 guaranteed consolation.", sourceUrl: "https://mnbarbingo.com/item/wild-boar-bar-grill-oakdale/" },
      { title: "Kids Costume Contest & Bingo", category: "Other", subcategories: [], date: "2026-10-24", time: "11:00", details: "Kids 12 and under. Costume contest around 12:30pm, then free kids bingo.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-events" },
      { title: "Big Money Bingo", category: "Gambling", subcategories: ["Bingo"], date: "2026-11-04", time: "18:30", details: "First Wednesday of every month. $2,000 guaranteed coverall. Wings 5 for $5.", sourceUrl: "https://oakdale.wildboarbarandgrill.com/oakdale-wild-boar-bar-and-grill-oakdale-events" },
    ],
  },
  {
    key: "jws",
    name: "JW's Bierstube",
    address: "7121 10th St N, Oakdale, MN 55128",
    phone: "(651) 731-8381",
    website: "",
    amenities: [],
    note: "Listing only. No website with specials found.",
    specials: [],
    events: [],
  },
  {
    key: "burrow",
    name: "The Burrow - Oakdale",
    address: "7053 10th St N, Oakdale, MN 55128",
    phone: "(651) 204-1900",
    website: "https://theburrowmn.com/oakdale",
    amenities: ["Axe Throwing", "Go-Karts", "Full Kitchen"],
    note: "Entertainment venue with a bar; 21+ after 9pm Fri–Sat. No specials listed on the site.",
    specials: [],
    events: [],
  },
  {
    key: "bww",
    name: "Buffalo Wild Wings - Oakdale",
    address: "8346 3rd St N, Oakdale, MN 55128",
    phone: "(651) 734-9464",
    website: "",
    amenities: [],
    note: "Listing only (national chain).",
    specials: [],
    events: [],
  },
];
